// Static UI mappings for real backend enums.
// (No data — that's fetched from the worker.)

export const STATUS = {
  open:        { key: "open",        label: "Open",         color: "#71717A" },
  assigned:    { key: "assigned",    label: "Assigned",     color: "#0047FF" },
  in_progress: { key: "in_progress", label: "In Progress",  color: "#F59E0B" },
  on_hold:     { key: "on_hold",     label: "On Hold",      color: "#A855F7" },
  resolved:    { key: "resolved",    label: "Resolved",     color: "#10B981" },
  closed:      { key: "closed",      label: "Closed",       color: "#22D3EE" },
  reopened:    { key: "reopened",    label: "Reopened",     color: "#EF4444" },
};

// Columns for the Kanban view (skip transient states)
export const KANBAN_COLUMNS = ["open", "assigned", "in_progress", "resolved", "closed"];

export const PRIORITY = {
  low:    { key: "low",    label: "Low",    color: "#71717A" },
  medium: { key: "medium", label: "Medium", color: "#0047FF" },
  high:   { key: "high",   label: "High",   color: "#F59E0B" },
  urgent: { key: "urgent", label: "Urgent", color: "#EF4444" },
};

// Palette used for category chips when the backend does not return a color
export const CATEGORY_PALETTE = [
  "#0047FF", "#22D3EE", "#F59E0B", "#EC4899",
  "#10B981", "#8B5CF6", "#0EA5E9", "#EF4444", "#BEF264",
];

export const colorFor = (id) => {
  const s = String(id ?? "0");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return CATEGORY_PALETTE[h % CATEGORY_PALETTE.length];
};

export const initialsOf = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0]?.toUpperCase() || "")
    .join("") || "?";

// Compute an SLA % from created_at + due_at (0 = fresh, 100 = due, >100 = breach)
export const slaPctOf = (t) => {
  if (!t?.created_at || !t?.due_at) return 0;
  const start = new Date(t.created_at).getTime();
  const due = new Date(t.due_at).getTime();
  const now = Date.now();
  if (isNaN(start) || isNaN(due) || due <= start) return 0;
  return Math.max(0, Math.min(200, Math.round(((now - start) / (due - start)) * 100)));
};

export const hoursAgo = (iso) => {
  if (!iso) return "—";
  const diff = (Date.now() - new Date(iso).getTime()) / 36e5;
  if (diff < 1) return `${Math.max(1, Math.round(diff * 60))}m`;
  if (diff < 48) return `${Math.round(diff)}h`;
  return `${Math.round(diff / 24)}d`;
};
